import React from "react";
import "./Footer.css";

const Footer = () => {
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  const texts = {
    about: lang === "bn" ? "আমাদের সম্পর্কে" : "About Us",
    contact: lang === "bn" ? "যোগাযোগ করুন" : "Contact Us",
    privacy: lang === "bn" ? "গোপনীয়তা নীতি" : "Privacy Policy",
    terms: lang === "bn" ? "ব্যবহারের শর্তাবলী" : "Terms of Use",
    faq: lang === "bn" ? "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী" : "FAQ",
    description:
      lang === "bn"
        ? "ড্রাইভিং থিওরি টেস্ট বাংলা অ্যাপটি ইউকের ড্রাইভিং টেস্টের জন্য প্রয়োজনীয় প্রশ্নগুলোর বাংলা অনুবাদ সরবরাহ করে। এটি ড্রাইভিং প্রস্তুতির জন্য একটি সহায়ক অ্যাপ।"
        : "Driving Theory Test Bangla app provides translated DVSA UK driving theory test questions in Bangla. It's a helpful app for driving preparation.",
    download: lang === "bn" ? "ডাউনলোড করুন" : "Download",
  };

  return (
    <footer className="footer-container">
      <img
        src="/Assets/Logos/app_logo.png"
        alt="Logo"
        /* style={{ height: "100%" }} */
        className="footer-logo"
      />
      <div className="footer-content">
        <p
          className={`footer-description ${
            lang === "bn" ? "footer-bangla" : ""
          }`}
        >
          {texts.description}
        </p>
        <div className="footer-links">
          <a
            href="/about"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.about}
          </a>{" "}
          ‧
          <a
            href="/privacy"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.privacy}
          </a>{" "}
          ‧
          <a
            href="/contact-us"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.contact}
          </a>
          {/* 
          
          <a
            href="/terms-of-use"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.terms}
          </a>
          <a
            href="/faq"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.faq}
          </a> */}
        </div>
        <div className="footer-download">
          <a
            href="https://play.google.com/store/apps/details?id=com.nuqi.drivingtheorytestbangla&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-store-link"
          >
            <img
              src="/Assets/playstore.png"
              alt="Play Store"
              className="footer-store-icon"
            />
          </a>
          <a
            href="https://apps.apple.com/app/driving-theory-test-bangla/id6749827058 "
            target="_blank"
            rel="noopener noreferrer"
            className="footer-store-link"
          >
            <img
              src="/Assets/appstore.png"
              alt="App Store"
              className="footer-store-icon"
            />
          </a>
        </div>
        <p className="footer-copyright">
          © {new Date().getFullYear()} NUQI. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
